var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
var stepMessageMap = {
    '12': "Great progress - don't give up now.",
    '19': "Keep going! You're almost done.",
};
export function Notes(_a) {
    var id = _a.id;
    if (!id || !stepMessageMap[id])
        return null;
    return _jsx(Typography, __assign({ className: 'font-extrabold text-sm text-charcoal' }, { children: stepMessageMap[id] }));
}
